module.exports = __webpack_public_path__ + "static/media/a1.1d03e6a8.jpg";